import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Shown when school affiliation was verified via the user's email domain.
 */
export default function VerifiedEmailBadge({
  affiliationStatus = 'none',
  affiliationMethod = null,
  className = ''
}) {
  const { t } = useTranslation();

  if (affiliationStatus !== 'verified' || affiliationMethod !== 'email') {
    return null;
  }

  return (
    <span
      className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium border bg-green-100 text-green-800 border-green-200 ${className}`}
      title={t('school.verifiedEmailBadgeTitle')}
    >
      <svg className="h-3 w-3 shrink-0" viewBox="0 0 20 20" fill="currentColor" aria-hidden>
        <path
          fillRule="evenodd"
          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
          clipRule="evenodd"
        />
      </svg>
      {t('school.verifiedEmailBadge')}
    </span>
  );
}
